module.exports = __webpack_public_path__ + "media/images/pic/teachers/magdalena-kisly-eb3ad00046c8abea0d6301b8d9dd5bed.webp";